<template>
  <main class="scroll-lock" style="height:520px" :class="{ boxPadding: isBox }">
    <section style="padding: 5px 0;" class="search container pb-0">
      <div class="row">
        <div class="col-10 offset-1">
          <form class="form">
            <div style="height: 40px" class="input-group input-lg mt-3">
              <div class="input">
                <input
                type="text"
                maxlength="100"
                name="keyword"
                id="keyword"
                class="form-control"
                style="height: 40px!important"
                v-model="keyword"
                @input="checkKeyword"
                @blur="checkKeyword"
                @keydown.enter="doSearch()"
                placeholder="輸入姓名、身分證或保單號碼進行搜尋..."
                alt="ch" />
              </div>
              <button
              class="btn btn-primary btn-icon"
              type="button"
              style="height: 40px"
              @click="doSearch()">
                <i class="icon-search i-24"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>

    <section class="container-fluid">
      <h4 class="text-green">
        客戶列表：{{tableDataBackup.length}}位  
        <a class="btn btn-default btn-sm m-0 padding-3-8" @click="clearCustomerType">清空客戶類型</a>
        <span class="text-red ml-3" v-show="insuranceType===2">(以下資訊係由產險提供，如需調整請洽產險窗口進行批改作業)</span>
        <div class="dropdown float-right">
          <button class="btn btn-default btn-sm m-0" aria-expanded="false" aria-haspopup="true"  data-toggle="dropdown" @click="dropmenuOpen = !dropmenuOpen">生日排序方式<i v-if="dropmenuOpen===false" class="icon-collapse_down"></i><i v-else class="icon-collapse_up"></i></button>
          <div class="dropdown-menu dropdown-menu-left w-180">
              <div class="radio radio-inline">
                <input
                  type="radio"
                  name="birthday-radio"
                  id="sort-radio1"
                  v-model="birthday_sort"
                  value="1"
                  @click="changeBirthdaySort('1')"
                />
                <label for="sort-radio1" class="text-green text-underline">以年-月-日排序</label>
              </div>
              <div class="radio radio-inline">
                <input
                  type="radio"
                  name="birthday-radio"
                  id="sort-radio2"
                  v-model="birthday_sort"
                  value="2"
                  @click="changeBirthdaySort('2')"
                />
                <label for="sort-radio2" class="text-green text-underline">以月-日-年排序</label>
              </div>
          </div>
        </div>
      </h4>
      <div class="form-group row search-checkbox " style="margin-bottom:0px;margin: 0px 0;">
        <div>
        <div class="checkbox checkbox-inline">
          <label class="d-inline-block">客戶類型(可複選)：</label>
        </div>
        <br>
        <label for="familyBtnUse" class="text-green text-underline conditions-use">{{selectCol[selectVal].text}}</label>
          <div class="checkbox checkbox-inline margin-right-10">
            <button type="button" id="familyBtnUse" class="btn-filter-use btn-enabled" aria-expanded="false" aria-haspopup="true" data-toggle="dropdown"><i class="icon-collapse_down"></i></button>
            <div class="dropdown-menu dropdown-menu-left margin-left-minus70">
              <a v-for="(item, index) in selectCol" :key="index" role="button" class="dropdown-item text-green text-underline" @click="selectVal = item.val">
                {{item.text}}
              </a>
            </div>
          </div>
        </div>        
        <div>
          <div class="checkbox checkbox-inline margin-right-set">
            <input
            type="checkbox"
            name="customer"
            id="customer-1"
            value="1"
            v-model="customerType"
            :disabled="searchLoading">
            <label for="customer-1" class="check-box-p-l-23">壽險客戶</label>
          </div>
          <br>
          <label class="conditions-use">{{select1[selectVal].text}}</label>
          </div>
        <div>
          <div class="checkbox checkbox-inline margin-right-set">
            <input
            type="checkbox"
            name="customer"
            id="customer-2"
            value="2"
            v-model="customerType"
            :disabled="searchLoading">
            <label for="customer-2" class="check-box-p-l-23">產險客戶</label>
          </div>
          <br>
          <label class="conditions-use">{{select2[selectVal].text}}</label>
        </div>
        <div>
          <div class="checkbox checkbox-inline margin-right-set">
            <input
            type="checkbox"
            name="customer"
            id="customer-3"
            value="3"
            v-model="customerType"
            :disabled="searchLoading">
            <label for="customer-3" class="check-box-p-l-23">旅平險客戶</label>
          </div>
          <br>
          <label class="conditions-use">{{select3[selectVal].text}}</label>
        </div>
        <div>
          <div class="checkbox checkbox-inline margin-right-set">
            <input
            type="checkbox"
            name="customer"
            id="customer-4"
            value="4"
            v-model="customerType"
            :disabled="searchLoading">
            <label for="customer-4" class="check-box-p-l-23">房貸客戶</label>
          </div>
          <br>
          <label class="conditions-use">{{select4[selectVal].text}}</label>
        </div>
        <div>
          <div class="checkbox checkbox-inline margin-right-set">
            <input
            type="checkbox"
            name="customer"
            id="customer-5"
            value="5"
            v-model="customerType"
            :disabled="searchLoading">
            <label for="customer-5" class="check-box-p-l-23">團險客戶</label>
          </div>
          <br>
          <label class="conditions-use">{{select5[selectVal].text}}</label>
        </div>
        <div>
          <div class="checkbox checkbox-inline margin-right-set">
            <input
            type="checkbox"
            name="customer"
            id="customer-6"
            value="6"
            v-model="customerType"
            :disabled="searchLoading">
            <label for="customer-6" class="check-box-p-l-23">準保戶</label>
          </div>
          <br>
          <label class="conditions-use">{{select6[selectVal].text}}</label>
        </div>
      </div>
    </section>
    <section>
    <div class="container-fluid">
      <div class="row">
        <data-table style="width: 78rem;" ref="dataTable"
        @update="updateSelection"
        @updateall="updateSelectAll"
        @openInfoModal="openCathayCustInfoModal"
        @openSurveyModal="openCathaySurveyModal"
        :options="insuranceType===1?tableOption:tableOption4Property" 
        :table-data="tableDataBackup"
        :currentPage="currentPage"
        :totalpages="totalpages"
        :addPageStatus="addPageStatus"
        :scroll-data-loading="scrollDataLoading"
        :scroll-message-loading="scrollMessageLoading"
        :remote-data-msg="remoteDataMsg"
        :dynamicLoading="true"
        :hasSearchBar="true"
        :isShowSurvey="true"
        :birthdaySortingType="birthday_sort"
        :is_open_mkt_type="is_open_mkt_type" />
      </div>
    </div>
    </section>
    <section class="container-fluid">
      <fixed-botton v-show="!isScroll">
        <template slot="@function">
          <div>
            <button class="btn btn-default"
            v-if="showDeleteBtn"
            @click="deleteResult"
            :disabled="!selection.length">
              刪除客戶
            </button>
            <button class="btn btn-primary"
            @click="openGroupModal"
            :disabled="!selection.length">
              加入群組
            </button>
            <button class="btn btn-primary mr-0"
            @click="openPrintModal"
            :disabled="!selection.length">
              列印名條
            </button>
          </div>
        </template>
      </fixed-botton>
    </section>
    <warning-modal
    :open="WarningModalOpen"
    :message="deleteWarningMessage"
    @close="panelClose('WarningModalOpen')"
    @submit="submitDeleteResult"/>

    <warning-modal
    :open="WarningDoubleCheckModalOpen"
    :message="WarningDoubleCheckModalMessage"
    :confirmText="`確認刪除`"
    @close="panelClose('WarningDoubleCheckModalOpen')"
    @submit="deleteCustomer"/>

    <print-modal
    :open="printModalOpen"
    :custs="selectionWithMobile"
    :checkall="checkAll_f"
    :customertype="customerType"
    :keyword="keyword"
    :order="order"
    @close="panelClose('printModalOpen')"/>

    <group-modal
    :open="groupModalOpen"
    :custs="selection"
    @submit="submitGroup"
    @showError="errorGroup"
    @close="panelClose('groupModalOpen')"/>

    <!-- 確認加入群組類型視窗 -->
    <confirm-group-modal
      :open="confirmGroupModalOpen"
      title="請選擇加入群組方式"
      @close="panelClose('confirmGroupModalOpen')"
      @addToCurrentGroup="addToCurrentGroup"
      @createNewGroup="createOneGroupOpen"
    />

    <!-- 成立新的群組視窗 -->
    <create-one-group-modal
      :open="createOneGroupModalOpen"
      :selectedCust="selection"
      type="SearchResultUse"
      @close="panelClose('createOneGroupModalOpen')"
      @createOneGroup="createOneGroup"
    />

    <!-- 泰好客說明視窗 -->
    <cathay-cust-info-modal
      :open="cathayCustInfoModalOpen"
      @close="panelClose('cathayCustInfoModalOpen')"
    />

    <!-- 問卷視窗 -->
    <survey-modal
      :open="surveyModalOpen"
      :csid="selectedCustID"
      @refresh="doRefresh"
      @close="panelClose('surveyModalOpen')"
    />

    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" :content="maskContent" />
  </main>
</template>

<script>
import { commonMixin } from '../../mixins/common'
import DataTable from '../../components/DataTable/DataTableScroll'
import { mapActions, mapGetters } from 'vuex'
import { getCustomers, setKeyWordLog, deleteCust, getCustHasFamily, insertBirthSort, deleteBirthSort, doSortList} from '../../service'

import Level from '../components/Level'
import Avatar from '../../components/Avatar'
import PrintModal from '../components/PrintModal'
import GroupModal from '../components/GroupModal'
import WarningModal from '../components/WarningModal'
import WarningDoubleCheckModal from '../components/WarningModal'

import { SearchResultMock } from '../../mock'
import FixedBotton from '../components/fixedBotton'
import mxMask from "@/desktop/components/mxMask"
import ConfirmGroupModal from "@/desktop/components/ConfirmGroupModal"
import CreateOneGroupModal from "@/desktop/components/CreateOneGroupModal"
import CathayCustInfoModal from "@/desktop/components/CathayCustInfoModal"
import SurveyModal from "@/desktop/components/SurveyModal"

const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad
let windowWidth = -525;
if(is_iPad){
  windowWidth = -480;
}

export default {
  name: 'SearchResult',
  mixins: [commonMixin],
  watch: {
    checkAll: 'toggleCheckAll',
    customerType : async function(newAry,oldAry) {
      this.$store.dispatch('updaCustType', this.handleCustomerType(newAry,oldAry));
      
      if( this.keyword !== this.QueryKeyword ){
        this.queryAction = ['N','N']
      }

      // 若勾選產險客戶(customerType若為2)，table不顯示「泰好客」&「公司往來」欄位      
      if( this.customerType[0] == '2'){
        this.tableOptionTemp =  this.tableOption4Property
        this.insuranceType = 2
        if( this.queryAction[1] == 'N' ){
          this.tableData_property = []
          this.tableDataBackup = []
          this.getCustomersAndSetup(this.$store.state.userInfo.id, this.keyword)
          this.queryAction[1] = 'Y'
        }
      }else{
        this.tableOptionTemp = this.tableOption
        this.insuranceType = 1
        if( this.queryAction[0] == 'N' ){
          this.tableData_nonproperty = []
          this.tableDataBackup = []
          await this.getCustomersAndSetup(this.$store.state.userInfo.id, this.keyword)
          this.queryAction[0] = 'Y'
        }
      }
  
      let val = newAry.find(function(e) {
        return e == 6;
      });
      if (newAry.length == 1 && val == 6){
        this.showDeleteBtn = true;
      } else {
        this.showDeleteBtn = false;
      }
      this.filterByFamily(this.selectVal);

    },
    //歸戶篩選
    selectVal: function(val) {
      this.filterByFamily(val);
    }
  },  
  components: {
    PrintModal, GroupModal, Level, Avatar, DataTable,WarningModal,WarningDoubleCheckModal,FixedBotton, mxMask, ConfirmGroupModal, CreateOneGroupModal, CathayCustInfoModal, SurveyModal
  },
  computed: {
    ...mapGetters(['BaseUrl', 'QueryKeyword', 'SliceMode', 'UserInfo']),
    isBox() {
      // 判斷是否為 box
      return this.UserInfo.userType === 'box';
    }
  },
  data () {
    return {
      remoteDataMsg: "資料讀取中，請稍候...",
      searchLoading: false,
      currentWidth: 0,
      currentScoll: 0,
      groupModalOpen: false,
      printModalOpen: false,
      forbidMultipleSent:false,
      addPageStatus: false,
      checkAll: false,
      checkAll_f:false ,
      WarningModalOpen:false,
      WarningDoubleCheckModalOpen:false,
      showDeleteBtn: false,
      selection: [],
      selectionWithMobile: [],
      customerType: ['1','3','4','5','6'],
      //customerType: ['1','3','4','5','6'], //移除產險客戶
      queryAction: ['Y','N'], //非產險、產險是否已查詢客戶api
      order:{
        order_by:'2',
        order_asc: true,
      },
      page:'1',
      pageSize: 99999,
      currentPage: 0,
      scrollDataLoading: false,
      scrollMessageLoading: false,
      totalpages: 0,
      totalCustomers: '?',
      keyword: '',
      resultTable: null,
      deleteWarningMessage:"您確定要刪除這些「準保戶」的客戶嗎？",
      WarningDoubleCheckModalMessage:"系統會同步刪除「<span style='color:red;'>客戶情報</span>」、「<span style='color:red;'>保單健檢</span>」及「<span style='color:red;'>建議書</span>」相關資訊，確認刪除後資料將無法回復，請確認是否刪除？",
      isScroll: false, //是否滾動
      is_iPad: is_iPad, //是否為ipad
      tableOption: {
        checkAll: true,
        scrollHeight: 350,
        isScrollLoading: true,
        checkBoxHasUser: true,
        insuranceType: 1, //自定義 1:壽險、2:產險
        columns: [
          {
            width: 125,
            name: "name",
            label: "姓名",
            sorting: true,
            insuranceType: 1,
            click: (data) => {
              this.routeToCustDetail(data)
            }
          },
          {
            width: 125,
            name: "showid",
            label: "身分證",
            sorting: true
          },
          {
            width: 125,
            name: "mobile",
            label: "手機",
            sorting: true
          },
          {
            width: 110,
            name: "birthday",
            label: "生日",
            sorting: true
          },
          {
            width: '*',
            name: "address",
            sorting: true,
            label: "住家地址"
          },
          {
            width: 151,
            name: "mkt_type",
            key:"search_result",
            label:"泰好客",
            sorting: true
          },
          {
            width: 101,
            name: "idmark",
            label: "公司往來"
          }
        ],
        sortByName: () => {
          this.order.order_asc = !this.order.order_asc
          this.sortByName();
        },
        scrollLoadingAPI: () => {
          this.scrollDataLoading = true
          this.scrollMessageLoading = true
          this.currentPage = this.currentPage + 1
          console.log("load more", 'page:'+　this.currentPage)
          // this.getCustomersPage(this.$store.state.userInfo.id, this.keyword)
          this.getCustomersPageNew();
        }
      },
      tableOption4Property: {
        checkAll: true,
        scrollHeight: 350,
        isScrollLoading: true,
        checkBoxHasUser: true,
        insuranceType: 2, //自定義 1:壽險、2:產險
        columns: [
          {
            width: 350,
            name: "name",
            label: "姓名",
            insuranceType: 2,
            sorting: true,
            click: (data) => {
              if(data.isPurePropertyCustomer)
                this.routeToPropertyCustDetail(data) //純產險客戶
              else
                this.routeToCustDetail(data) //同時為產險客戶又是壽險客戶
            }
          },
          {
            width: 350,
            name: "showid",
            label: "身分證",
            sorting: true
          },
          {
            width: "*",
            name: "birthday",
            label: "生日",
            sorting: true
          }
        ],
        sortByName: () => {
          this.order.order_asc = !this.order.order_asc
          this.sortByName();
        },
        scrollLoadingAPI: () => {
          this.scrollDataLoading = true
          this.scrollMessageLoading = true
          this.currentPage = this.currentPage + 1
          this.getCustomersPageNew();
        }
      },
      tableOptionTemp: {},
      tableData: [],
      tableData_nonproperty:[],
      tableData_property:[],
      tableDataBackup: [],
      bottomWidth: windowWidth,
      mxMaskOpen: false,
      confirmGroupModalOpen: false,
      createOneGroupModalOpen: false,
      dropmenuOpen:false, //生日排序方式下拉
      birthday_sort:"1", //生日排序方式(1:年-月-日 2:月-日-年)
      selectVal: 0,
      selectCol:[
        { val: 0, text: "全部"},
        { val: 1, text: "已歸戶"},
        { val: 2, text: "未歸戶"}
      ],
      select1:[
        { val: 0, text: "壽險全部"},
        { val: 1, text: "壽險已歸戶"},
        { val: 2, text: "壽險未歸戶"}
      ],
       select2:[
         { val: 0, text: "產險全部"},
         { val: 1, text: "產險已歸戶"},
         { val: 2, text: "產險未歸戶"}
       ],
      select3:[
        { val: 0, text: "旅平險全部"},
        { val: 1, text: "旅平險已歸戶"},
        { val: 2, text: "旅平險未歸戶"}
      ],
      select4:[
        { val: 0, text: "房貸全部"},
        { val: 1, text: "房貸已歸戶"},
        { val: 2, text: "房貸未歸戶"}
      ],
      select5:[
        { val: 0, text: "團險全部"},
        { val: 1, text: "團險已歸戶"},
        { val: 2, text: "團險未歸戶"}
      ],
      select6:[
        { val: 0, text: "準保戶全部"},
        { val: 1, text: "準保戶已歸戶"},
        { val: 2, text: "準保戶未歸戶"}
      ],
      custHasFamilyList:[], //已歸戶的客戶
      hasFamily:"1", //1:全部, 2:已歸戶, 3:未歸戶
      maskContent:"", //遮罩顯示訊息
      cathayCustInfoModalOpen: false,
      surveyModalOpen: false, //問卷視窗開啟
      selectedCustID:"", //點選的客戶ID
      is_open_mkt_type: "N", //是否開啟行銷分
      insuranceType: 1 // 1:壽險 2:產險
    }
  },
  methods: {
    handleCustomerType(newAry,oldAry){
      if(newAry.length !== 0 && oldAry.length !== 0){
          const addNum = newAry.find(item => !oldAry.includes(item))
          if(addNum == 2){
            this.customerType = ['2']
            return this.customerType
          }else if(addNum !== undefined && newAry.length === 2 && newAry.includes('2')){
            this.customerType = []
            this.customerType.push(addNum)
            return this.customerType
          }         
          return newAry       
      }
    },
    //檢查輸入欄位
    checkKeyword(){
      this.keyword = this.keyword.replace(/[<>!@#$^&,."'?%;_()+-/{}[\]|~`=\\\s]/g,'');
      if (this.stringBytes(this.keyword, false, 100) > 100) {
        this.keyword = this.keyword.substring(0, this.stringBytes(this.keyword, true ,100));
      }
    },
    ...mapActions([
      'setPageLock' , 'updateCustID' , 'updateQueryKeyword' , 'updateSerNo', 'updateCustInfo'
    ]),
    deleteResult(){
      this.panelOpen('WarningModalOpen')
    },
    submitDeleteResult(){
      this.panelClose('WarningModalOpen')
      this.panelOpen('WarningDoubleCheckModalOpen')
    },
    updateSelection (val) {
      this.selection = val
    },
    updateSelectAll (val) {
      this.checkAll_f = val
    },
    openGroupModal () { // 判斷無ID客戶才能開啟 modal
      // let checkID = /^\d{8}/g
      let aryHasSerNo = false
      this.selection.forEach(item => {
        if(item === ''){
          aryHasSerNo = true
        }
      })
      if(aryHasSerNo){
        this.$toast.info({title: '選擇項目不得有 (無身分證) 用戶'})
      }else{

        this.panelOpen('confirmGroupModalOpen')
      }
    },
    openPrintModal () { // 判斷無ID客戶才能開啟 modal
      this.selection = this.sortByPattern('id', this.tableDataBackup, this.selection)
      this.selectionWithMobile = [];
      this.selection.forEach(sel => {
        let tmpData = this.tableData.find(data => {
          return data.id === sel;
        });
        if(tmpData) {
          this.selectionWithMobile.push(tmpData);
        }
      });
      this.panelOpen('printModalOpen')
    },
    sortByPattern(propertyStr, patternObjectArray, targetArray) {
      var targetWithIndexArray = []
      var targetCount = targetArray.length
      var patternCount = patternObjectArray.length
      for(var i=0; i<targetCount; i++) {
        var targetProperty = targetArray[i]
        for(var j=0; j<patternCount; j++) {
          if(targetProperty == patternObjectArray[j][propertyStr]) {
            var obj = {}
            obj['index'] = j
            obj[propertyStr] = targetProperty
            targetWithIndexArray.push(obj)
            break;
          }
        }
      }
      var sortedArray = targetWithIndexArray.sort(this.sortCompareFun(1, 'index'))
      return sortedArray.map((ele) => {return ele[propertyStr]})
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
      }
    },
    submitGroup (group) {
      // add group methods
      this.panelClose('groupModalOpen')
      this.$router.push({path:`/group/1`, query:{grp_id: group.grp_id, grp_name: group.grp_name}})
    },
    errorGroup (errList) {
      let errMsg = ''
      let copmreMap = {}
      
      this.tableData.forEach(item => {
        console.log(item)
        copmreMap[item.id] = item.name
      })
      console.log(this.compreMap)

      errList.forEach(ele => {
            
              errMsg = errMsg + '客戶: ' + copmreMap[ele] + ' 已達群組上限，\n'
            });

            errMsg = errMsg + '如需調整請至群組管理!!'

      this.$toast.info({title: errMsg})
      this.panelClose('groupModalOpen')
    },
    toggleCheckAll (val) {
      if (val) {
        this.selection = this.tableDataBackup.map(item => {return item.id})
        
      } else {
        this.selection = []
      }
    },
    routeToCustDetail(cust) {
      let custId = cust.id;
      if (this.isBox) {
        this.boxCustInfo(custId, cust.name);
        return;
      }
      if(custId !== '' && cust.serNo === ''){
        this.updateCustID(custId)
        this.updateSerNo('')
        localStorage.CustID = custId
        localStorage.SerNo = ''
        this.$router.push({path: `/detail/CustID/tab/1`})
      }else{
        this.updateSerNo(cust.serNo)
        this.updateCustID('')
        localStorage.CustID = ''
        localStorage.SerNo = cust.serNo
        this.$router.push({path: `/detail/SerNo/tab/1`})
      }
      localStorage.checkMvBack = true
    },
    routeToPropertyCustDetail(cust){
      let custId = cust.id;
      if (this.isBox) {
        this.boxPropertyCustInfo(custId, cust.name);
        return;
      }
      if(custId !== '' && cust.serNo === ''){
        localStorage.CustID = custId
        localStorage.SerNo = ''
        this.updateCustInfo(cust)
        this.$router.push({
          path: `/property-detail/CustID/tab/1`,
        })
      }else{
        localStorage.CustID = ''
        localStorage.SerNo = cust.serNo
        this.updateCustInfo(cust)
        this.$router.push({
          path: `/property-detail/SerNo/tab/1`,
        })
      }
      localStorage.checkMvBack = true
    },
    async getCustomersAndSetup(agntId, keyword) {
      this.addPageStatus = false
      let s1 = ''
      let s2 = ''
      let s3 = ''
      let s4 = ''
      let s5 = ''
      let s6 = ''
      if( this.queryAction[0] == 'N' && this.customerType[0] !== '2'){
        s1 = '1'
        s2 = 'N'
        s3 = '1'
        s4 = '1'
        s5 = '1'
        s6 = '1'
      }else{
        s1 = this.customerType.includes('1') ? '1' : 'N'
        s2 = this.customerType.includes('2') ? '1' : 'N'
        s3 = this.customerType.includes('3') ? '1' : 'N'
        s4 = this.customerType.includes('4') ? '1' : 'N'
        s5 = this.customerType.includes('5') ? '1' : 'N'
        s6 = this.customerType.includes('6') ? '1' : 'N'
      }
      let order_by = this.order.order_by
      let order_asc = this.order.order_asc === true ? '1' : '2'
      let page = this.page
      this.remoteDataMsg="資料讀取中，請稍候..."
      this.updateQueryKeyword(this.keyword)
      this.selection = []
      this.checkAll = false
      this.scrollDataLoading = false 
      if(!this.forbidMultipleSent){   // 禁止 request 重複送出
        this.forbidMultipleSent = true
        setKeyWordLog(this.$store.state.userInfo.id,this.QueryKeyword) // 新增查詢關鍵字log
        this.searchLoading = true
        await getCustomers(agntId, keyword, s1, s2, s3, s4, s5, s6, page, order_by, order_asc,'99999').then(result => {
          this.searchLoading = false
          let resBody = result.body || {};
          this.is_open_mkt_type = resBody.is_open || "N"; //是否開啟行銷分
          if(resBody.customer_list) {
            this.totalCustomers = result.body.totalcusts
            this.totalpages = Math.floor((this.totalCustomers / 200) + 1);
            this.tableData = resBody.customer_list.map(eachCust => {
              let idmarkSource1 = eachCust.idmark.source1 && eachCust.idmark.source1 == '1' ? '1': '0'
              let idmarkSource2 = eachCust.idmark.source2 && eachCust.idmark.source2 == '1' ? '2': '0'
              let idmarkSource3 = eachCust.idmark.source3 && eachCust.idmark.source3 == '1' ? '3': '0'
              let idmarkSource4 = eachCust.idmark.source4 && eachCust.idmark.source4 == '1' ? '4': '0'
              let idmarkSource5 = eachCust.idmark.source5 && eachCust.idmark.source5 == '1' ? '5': '0'
              let idmarkSource6 = eachCust.idmark.source6 && eachCust.idmark.source6 == '1' ? '6': '0'
              let val = eachCust.address
              if(val && val.trim() && val !== '— —'){
                val = val.trim()
                let pattern = /^[0-9]+$/;
                let firstWords = val.substring(0, 5)
                let len = val.length;
                if (pattern.test(firstWords)) {
                  let words = val.substring(5, len);
                  val = eachCust.address.substring(0, 3);
                  val = val + words;          
                }else{
                  val = eachCust.address; 
                }
              }
              let ageText = this.paddingLeft(eachCust.age == "0" ? "0" : eachCust.age ? eachCust.age : "00000", 4, "0");
              let birthdayText = eachCust.birthday || "0000-01-01";
              return {
                index: eachCust.index || '',
                vip_level : Number(eachCust.vip_level) || 0,
                sex : Number(eachCust.sex) || 0,
                name : eachCust.name || '',
                age: eachCust.age,
                id : eachCust.id || eachCust.ser_no || '',
                serNo : eachCust.ser_no || '',
                mobile : eachCust.mobile || '',
                phone : eachCust.phone || '',
                birthday : eachCust.birthday || '',
                birthdaySort : ageText + "_" + birthdayText,
                address : val || '',
                idmark : [idmarkSource1, idmarkSource2, idmarkSource3, idmarkSource4, idmarkSource5, idmarkSource6],
                showid : eachCust.id || '',
                company_address : eachCust.company_address || '',
                customertype1: eachCust.customertype1 || '0',
                customertype2: eachCust.customertype2 || '0',
                customertype3: eachCust.customertype3 || '0',
                customertype4: eachCust.customertype4 || '0',
                customertype5: eachCust.customertype5 || '0',
                customertype6: eachCust.customertype6 || '0',
                hos_mkt_level: eachCust.hos_mkt_level || '',
                sur_mkt_level: eachCust.sur_mkt_level || '',
                rei_mkt_level: eachCust.rei_mkt_level || '',
                acc_mkt_level: eachCust.acc_mkt_level || '',
                dd_mkt_level: eachCust.dd_mkt_level || '',
                ltc_mkt_level: eachCust.ltc_mkt_level || '',
                life_mkt_level: eachCust.life_mkt_level || '',
                sav_mkt_level: eachCust.sav_mkt_level || '',
                inv_mkt_level: eachCust.inv_mkt_level || '',
                crm_highlight: eachCust.crm_highlight || '',
                box_highlight: eachCust.box_highlight || '',                
                mkt_score : this.getMktScore(eachCust),
                isPurePropertyCustomer: this.checkIsPurePropertyCustomer(this.insuranceType,eachCust),
                is_lia : eachCust.is_lia || '',
              }
            })
            //查詢已歸戶客戶 & 預設生日排序
            getCustHasFamily(agntId).then(result => {
              if(result.header && result.header.status === "200" && result.body.result && result.body.birthsort) {
                this.birthday_sort = result.body.birthsort;//預設生日排序
                this.custHasFamilyList = result.body.result.map(item => {
                  return item.csidno;
                });
              } else {
                this.custHasFamilyList = [];
              }
            })
          } else {
            this.tableData = []
            this.totalCustomers = '0'
            this.custHasFamilyList = [];
          }
          if(this.customerType[0] == '2'){
            this.tableData_property =  this.tableData
            this.tableDataBackup = this.tableData_property.slice(0, this.pageSize);
          }else{
            this.tableData_nonproperty =  this.tableData
            this.tableDataBackup = this.tableData_nonproperty.slice(0, this.pageSize);
          }          
          this.currentPage = 1
          if(this.currentPage == this.totalpages){
            this.scrollDataLoading = true
            this.scrollMessageLoading = false
          }else{
            this.scrollMessageLoading = false
          }
          //this.customerType = this.$store.state.custType; //因過濾改在前端處理，必須先撈回所有資料再過濾
          if (this.selectVal) {
            this.filterByFamily(this.selectVal); //頁面初始化預帶全部，不觸發過濾
          }
          this.$refs.dataTable.resetPosition();
          this.forbidMultipleSent = false
          this.remoteDataMsg="查無資料，請確認您輸入之資料是否正確"
        })
      }
      this.tableOption.scrollHeight = $(window).height() - 290
      this.tableOption4Property.scrollHeight = $(window).height() - 290
    },
    getCustomersPage(agntId, keyword) {
      this.addPageStatus = true
      let s1 = this.customerType.includes('1') ? '1' : 'N'
      let s2 = this.customerType.includes('2') ? '1' : 'N'
      let s3 = this.customerType.includes('3') ? '1' : 'N'
      let s4 = this.customerType.includes('4') ? '1' : 'N'
      let s5 = this.customerType.includes('5') ? '1' : 'N'
      let s6 = this.customerType.includes('6') ? '1' : 'N'
      let order_by = this.order.order_by
      let order_asc = this.order.order_asc === true ? '1' : '2'
      let currentPage = Number(this.currentPage)
      
      if(!this.forbidMultipleSent){
        this.forbidMultipleSent = true
        getCustomers(agntId, keyword, s1, s2, s3, s4, s5, s6, currentPage, order_by, order_asc,'99999').then(result => {
          let newTableData = result.body.customer_list.forEach(eachCust => {
            let idmarkSource1 = eachCust.idmark.source1 && eachCust.idmark.source1 == '1' ? '1': 'N'
            let idmarkSource2 = eachCust.idmark.source2 && eachCust.idmark.source2 == '1' ? '2': 'N'
            let idmarkSource3 = eachCust.idmark.source3 && eachCust.idmark.source3 == '1' ? '3': 'N'
            let idmarkSource4 = eachCust.idmark.source4 && eachCust.idmark.source4 == '1' ? '4': 'N'
            let idmarkSource5 = eachCust.idmark.source5 && eachCust.idmark.source5 == '1' ? '5': 'N'
            let idmarkSource6 = eachCust.idmark.source6 && eachCust.idmark.source6 == '1' ? '6': 'N'
            this.tableData.push({
              index: eachCust.index || '',
              age: eachCust.age,
              vip_level : Number(eachCust.vip_level) || 0,
              sex : Number(eachCust.sex) || 0,
              name : eachCust.name || '',
              id : eachCust.id || '',
              serNo : eachCust.ser_no || '',
              mobile : eachCust.mobile || '',
              phone : eachCust.phone || '',
              birthday : eachCust.birthday || '',
              address : eachCust.address || '',
              idmark : [idmarkSource1, idmarkSource2, idmarkSource3, idmarkSource4, idmarkSource5, idmarkSource6],
            })
          })
          if(this.currentPage !== this.totalpages){
            this.scrollMessageLoading = false
            this.scrollDataLoading = false
          }else{
            this.scrollMessageLoading = false
          }
          this.forbidMultipleSent = false
          this.remoteDataMsg="查無資料，請確認您輸入之資料是否正確"
        })
        setTimeout(() => {
          this.addPageStatus = false
        }, 200);
      }
    },
    getCustomersPageNew() {
      this.addPageStatus = true;
      const begin = (this.currentPage - 1) * this.pageSize;
      this.tableDataBackup.push(...this.tableData.slice(begin, begin + this.pageSize));
      
      if (this.currentPage !== this.totalpages) {
        this.scrollMessageLoading = false;
        this.scrollDataLoading = false;
      } else {
        this.scrollMessageLoading = false;
      }

      setTimeout(() => {
        this.registerHanlink()
      }, 2000);
    },
    checkIsPurePropertyCustomer(insuranceType , custObj){
      if( insuranceType == 1)
        return false
      if(custObj.customertype1 == 0 && custObj.customertype3 == 0 && custObj.customertype4 == 0 && custObj.customertype5 == 0 && custObj.customertype6 == 0 )
        return true

      return false
    },
    doSearch () {
      if (!this.$store.state.compositionStatus) {
        this.tableData = []
        this.tableDataBackup = []
        this.selection = []
        if( this.keyword !== this.QueryKeyword ){
          this.queryAction = ['N','N']
        }
        if(this.customerType[0] == '2'){
          this.tableData_property = []
          if( this.queryAction[1] == 'N' ){
            this.queryAction[1] = 'Y'
          }
        }else{
          this.tableData_nonproperty = []
          if( this.queryAction[0] == 'N' ){
            this.queryAction[0] = 'Y'
          }
        }  
        this.getCustomersAndSetup(this.$store.state.userInfo.id, this.keyword)
      }
    },
    deleteCustomer () {
      this.maskContent = "資料刪除中，請稍候...";
      this.panelOpen("mxMaskOpen");//開啟遮罩
      deleteCust(this.$store.state.userInfo.id, "csids", "", "", this.selection, this.keyword).then(result =>{
        this.panelClose("mxMaskOpen");//關閉遮罩
        if (result && result.header.status == '200') {
          this.panelClose('WarningDoubleCheckModalOpen')
          this.$toast.info({title: `刪除成功`})
          this.$router.push({path:`/`})
        }
        else {  
          this.panelClose('WarningDoubleCheckModalOpen')
          this.$toast.info({title: `刪除失敗`})
        }
      })         
    },
    handleScroll() {
      // ----滾動顯示/隱藏----
      this.isScroll = true;
      clearTimeout(this.scrolltimeOutProcessId);
      this.scrolltimeOutProcessId = setTimeout(() => {
        this.isScroll = false;
      }, 500);
      // ----滾動顯示/隱藏----
    },
    stringBytes(c, isSub, size){ //計算字元長度 (字串, 是否檢查, 檢查的長度) 
      var n=c.length,s;
      var len=0;
      for(var i=0; i <n;i++){
        s=c.charCodeAt(i);
        while( s > 0 ){
          len++;
          s = s >> 8;
          if(isSub&&len>size){
            return i;
          }
        }
      }
      return len;
    },
    //導頁至加入現有群組(view)
    addToCurrentGroup() {
      this.panelClose("confirmGroupModalOpen");
      let selectionInfo = this.getSelectedCustInfo();
      this.$router.push({
        name: "add-to-current-group",
        params: { selectedCust: selectionInfo }
      });
    },
    //開啟成立新的群組視窗
    createOneGroupOpen() {
      this.panelClose("confirmGroupModalOpen");
      this.panelOpen("createOneGroupModalOpen");
    },
    //導頁至成立新的群組(view)
    createOneGroup(groupName) {
      let selectionInfo = this.getSelectedCustInfo();
      this.panelClose("createOneGroupModalOpen");
      this.$router.push({
        name: "create-one-group",
        params: { selectedCust: selectionInfo, groupName: groupName }
      });
    },
    //取得當前勾選客戶的資料
    getSelectedCustInfo() {
      let selectionInfo = [];
      this.selection.forEach(sel => {
        let tmpData = this.tableData.find(data => {
          return data.id === sel;
        });
        if (tmpData) {
          selectionInfo.push({
            showid: tmpData.id.startsWith("~") ? "" : tmpData.id,
            id: tmpData.id,
            name: tmpData.name,
            birthday: tmpData.birthday
          });
        }
      });
      return selectionInfo;
    },
    //清空客戶類型
    clearCustomerType() {
      if(!this.customerType.length) {
        return;
      }
      this.customerType = [];
    },
    //切換生日排序方式
    changeBirthdaySort(val) {
      if (val == this.birthday_sort) {
        return;
      }
      this.$refs.dataTable.columnSorting(5);
      this.maskContent = "儲存預設生日排序中，請稍候...";
      this.panelOpen("mxMaskOpen"); //開啟遮罩
      if (val == "1") {
        deleteBirthSort(this.$store.state.userInfo.id).then(result => {
          this.panelClose("mxMaskOpen"); //關閉遮罩
          if (result && result.header.status == "200") {
            console.log("刪除預設生日排序成功");
          } else {
            console.log("刪除預設生日排序失敗");
          }
        });
      } else {
        insertBirthSort(this.$store.state.userInfo.id).then(result => {
          this.panelClose("mxMaskOpen"); //關閉遮罩
          if (result && result.header.status == "200") {
            console.log("新增預設生日排序成功");
          } else {
            console.log("新增預設生日排序失敗");
          }
        });
      }
    },
    //計算泰好客加權分數
    getMktScore(data) {
      if (data.customertype1 != "1") {
        return -1; //目前無泰好客資訊，則分數為-1
      }
      let mktType = ["hos_mkt_level", "sur_mkt_level", "rei_mkt_level",
       "acc_mkt_level", "dd_mkt_level", "ltc_mkt_level", "life_mkt_level", "sav_mkt_level", "inv_mkt_level"];
      let returnScore = 0;

      //類型為1(分數2)，類型為2 or 3 (分數1)，其餘分數0
      mktType.forEach(value => {
        if (data[value] == "1") {
          returnScore += 2;
        } else if(data[value] == "2" || data[value] == "3") {
          returnScore += 1;
        }
      });

      return returnScore;
    },
    sortByName() {
      if(this.tableDataBackup.length == 0) {
        return;
      }

      let tempData = this.tableDataBackup;
      this.tableDataBackup = [];
      this.remoteDataMsg = "資料排序中，請稍候...";
      doSortList(
        this.$store.state.userInfo.id,
        this.order.order_asc ? "1" : "-1",
        tempData,
        "name"
      ).then(result => {
        if (result.header && result.header.status === "200") {
            this.tableDataBackup = result.body.result;
            this.tableDataBackup.forEach((item, index) => {
              item.index = `${index + 1}`;
            } );
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "姓名排序異常,請重新操作" });
          }
          this.tableDataBackup = tempData;
        }
        this.remoteDataMsg = "查無資料，請確認您輸入之資料是否正確";
      });
    },
    //過濾非產險客戶類型
    filterByType() {
      this.checkAll = false;
      this.selection = [];
      this.tableDataBackup = [];
      setTimeout(() => {
        this.tableDataBackup = this.tableData_nonproperty.filter(item => {
          if (this.customerType.includes("1")) {
            if (item.customertype1 == "1") {
              return item;
            }
          }
          if (this.customerType.includes("2")) {
            if (item.customertype2 == "1") {
              return item;
            }
          }
          if (this.customerType.includes("3")) {
            if (item.customertype3 == "1") {
              return item;
            }
          }
          if (this.customerType.includes("4")) {
            if (item.customertype4 == "1") {
              return item;
            }
          }
          if (this.customerType.includes("5")) {
            if (item.customertype5 == "1") {
              return item;
            }
          }
          if (this.customerType.includes("6")) {
            if (
              item.customertype1 == "0" &&
              item.customertype3 == "0" &&
              item.customertype4 == "0" &&
              item.customertype5 == "0" &&
              item.customertype6 == "1"
            ) {
              return item;
            }
          }
        });
        //重給編號
        let sn = 1;
        this.tableDataBackup.forEach(item => {
          item.index = sn;
          sn++;
        });
        this.registerHanlink(); // 難字顯示
      }, 10);
    },
    //過濾歸戶類型
    filterByFamily(val) {
      // if (this.tableData && !this.tableData.length) {
      //   return; //沒資料不過濾
      // }    
      
      if( this.customerType[0] !== '2'){
        this.filterByType();
      }else{   
        this.tableDataBackup = this.tableData_property
      }

      if (val == "0") {
        return; //歸戶類型全部
      }
      
      setTimeout(()=>{
        let tempList= this.tableDataBackup.filter(item => {       
          return  item.id && val == "1" ? this.custHasFamilyList.includes(item.id) : !this.custHasFamilyList.includes(item.id)
        })
        //重給編號
        let sn = 1;
        tempList.forEach(item => {
          item.index = sn;
          sn++;
        });
        this.tableDataBackup = [...tempList];
        this.registerHanlink(); // for 難字更新
      },30)

    },
    //開啟泰好客說明視窗
    openCathayCustInfoModal () {
      this.panelOpen('cathayCustInfoModalOpen');
    },
    //開啟問卷視窗
    openCathaySurveyModal(cust) {
      this.selectedCustID = cust.id
      this.panelOpen('surveyModalOpen');
    },
    //關閉問卷並更新問券狀態
    doRefresh() {
      this.panelClose('surveyModalOpen');
      this.tableDataBackup.forEach(item => {
        if (item.id == this.selectedCustID && item.crm_highlight == "1") {
          item.crm_highlight = "0";
        }
      });

      this.tableData.forEach(item => {
        if (item.id == this.selectedCustID && item.crm_highlight == "1") {
          item.crm_highlight = "0";
        }
      });
    }
  },
  mounted () {
    window.addEventListener("scroll", this.handleScroll, true);
    this.keyword = this.QueryKeyword
    this.getCustomersAndSetup(this.$store.state.userInfo.id, this.QueryKeyword)
    let self = this;
    $(window).bind('orientationchange', function(event) {
      $(window).one('resize', function() {
        self.tableOption.scrollHeight = $(window).height() - 310
        self.tableOption4Property.scrollHeight = $(window).height() - 310
      });
    });
  },
}
</script>

<style scoped>


.newTable thead tr,.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.newTable tbody {
  display: block;
  height: 200px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

.title-use {
  font-size: 20px;
  margin-bottom: 0.5rem;
  font-family: inherit;
  line-height: 1.2;
  display: block;
  margin-block-start: 1.33em;
  margin-block-end: 1.33em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}

.margin-right-set {
  margin-right:30px;
}

.margin-right-10 {
  margin-right:10px;
}

.conditions-use {
  font-weight: 600;
  padding-left: 30px;
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1025px) and (-webkit-min-device-pixel-ratio: 1) {
  .margin-right-set {
    margin-right:25px;
  }

  .margin-right-10 {
    margin-right:2px;
  }

  .conditions-use {
    padding-left: 23px;
  }

  .check-box-p-l-23 {
    padding-left: 23px;
  }
}

.w-150 {
  width:150px;
}

.w-180 {
  width:180px;
}

.margin-left-minus70 {
  margin-left:-70px;
}

.btn-filter-use {
  color: #F58818;
  border: 0px;
  font-size:16px;
  font-weight: 600;
  padding-top:10px;
  cursor: pointer;
}

.btn-enabled {
  background:transparent !important;
}

.boxPadding {
  padding-top: 0px !important;
}

</style>

